var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('VueMarkdown',{staticClass:"md",staticStyle:{"text-align":"center"},attrs:{"loading":"lazy","source":_vm.team}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }